<template>
  <div class="sidebar">
    <div class="sidebar__wrapper">
      <div class="brand">
        <img src="/img/stacks.png" alt="Stacks Logo">
      </div>
      <div class="navlinks">
        <div
          class="navlinks__item"
        >
          <InertiaLink
            v-tippy="{
              arrow : true,
              arrowType : 'sharp',
              placement : 'right',
              animation : 'shift-away'
            }"
            content="Dashboard"
            href="/dashboard"
            :class="{ 'navlinks__link--active': isUrl('dashboard') }"
            class="navlinks__link"
          >
            <i class="icon icon-zoom" />
          </InertiaLink>
        </div>

        <div
          v-if="$page.props.settings.application_mode === 'queueing'"
          class="navlinks__item"
        >
          <InertiaLink
            v-tippy="{
              arrow : true,
              arrowType : 'sharp',
              placement : 'right',
              animation : 'shift-away'
            }"
            content="Counters"
            href="/counters"
            :class="{ 'navlinks__link--active': isUrl('counters') }"
            class="navlinks__link"
          >
            <i class="icon icon-grid-interface" />
          </InertiaLink>
        </div>

        <div class="navlinks__item">
          <InertiaLink
            v-tippy="{
              arrow : true,
              arrowType : 'sharp',
              placement : 'right',
              animation : 'shift-away'
            }"
            content="Playlists"
            href="/playlists"
            :class="{ 'navlinks__link--active': isUrl('playlists') }"
            class="navlinks__link"
          >
            <i class="icon icon-media-player" />
          </InertiaLink>
        </div>

        <div class="navlinks__item">
          <InertiaLink
            v-tippy="{
              arrow : true,
              arrowType : 'sharp',
              placement : 'right',
              animation : 'shift-away'
            }"
            content="Assets"
            href="/assets"
            :class="{ 'navlinks__link--active': isUrl('assets') }"
            class="navlinks__link"
          >
            <i class="icon icon-catalog" />
          </InertiaLink>
        </div>


        <div class="navlinks__item">
          <InertiaLink
            v-tippy="{
              arrow : true,
              arrowType : 'sharp',
              placement : 'right',
              animation : 'shift-away'
            }"
            content="News"
            href="/news"
            :class="{ 'navlinks__link--active': isUrl('news') }"
            class="navlinks__link"
          >
            <i class="icon icon-news" />
          </InertiaLink>
        </div>

        <div class="navlinks__item">
          <InertiaLink
            v-tippy="{
              arrow : true,
              arrowType : 'sharp',
              placement : 'right',
              animation : 'shift-away'
            }"
            content="Settings"
            href="/settings/users"
            :class="{ 'navlinks__link--active': isUrl('settings') }"
            class="navlinks__link"
          >
            <i class="icon icon-settings-gear" />
          </InertiaLink>
        </div>
      </div>
      <button
        v-tippy="{
          arrow : true,
          arrowType : 'sharp',
          placement : 'right',
          animation : 'shift-away'
        }"
        content="Help?"
        class="button button--icon"
      >
        <i class="icon icon-c-question" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
}
</script>
